var _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthKoreaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7332_45182)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H0V15H21V0Z",
    fill: "url(#paint0_linear_7332_45182)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7332_45182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 7,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7332_45182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11Z",
    fill: "url(#paint1_linear_7332_45182)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99999 8C7.99999 8.9375 9.49999 9.5 10.5 8C11.5 6.5 13.5 6.5 14 8C14.5 9.5 14 11 14 11H6.99999C6.99999 11 5.99999 7.0625 6.99999 8Z",
    fill: "url(#paint2_linear_7332_45182)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.208 3.92309C14.1374 3.80075 14.1728 3.64807 14.2987 3.57541L14.7276 3.32775C14.8483 3.25807 15.0031 3.30025 15.0741 3.42309L16.3183 5.57814C16.3889 5.70048 16.3535 5.85316 16.2276 5.92583L15.7987 6.17348C15.678 6.24317 15.5232 6.20098 15.4523 6.07814L14.208 3.92309ZM15.5071 3.17309C15.4364 3.05075 15.4719 2.89807 15.5977 2.82541L16.0267 2.57775C16.1474 2.50807 16.3022 2.55025 16.3731 2.67309L17.6173 4.82814C17.6879 4.95048 17.6525 5.10316 17.5267 5.17583L17.0977 5.42348C16.977 5.49317 16.8222 5.45098 16.7513 5.32814L15.5071 3.17309ZM3.38271 10.1731C3.31208 10.0508 3.3475 9.89807 3.47336 9.82541L3.90231 9.57775C4.02301 9.50807 4.17782 9.55025 4.24874 9.67309L5.49296 11.8281C5.56359 11.9505 5.52817 12.1032 5.40231 12.1758L4.97336 12.4235C4.85266 12.4932 4.69785 12.451 4.62693 12.3281L3.38271 10.1731ZM4.68175 9.42309C4.61112 9.30075 4.64654 9.14807 4.7724 9.07541L5.20135 8.82775C5.32204 8.75807 5.47686 8.80025 5.54778 8.92309L6.792 11.0781C6.86263 11.2005 6.82721 11.3532 6.70135 11.4258L6.2724 11.6735C6.1517 11.7432 5.99689 11.701 5.92597 11.5781L4.68175 9.42309ZM15.4523 8.92309C15.5229 8.80075 15.6728 8.75509 15.7987 8.82775L16.2276 9.07541C16.3483 9.14509 16.3892 9.30025 16.3183 9.42309L15.0741 11.5781C15.0034 11.7005 14.8535 11.7461 14.7276 11.6735L14.2987 11.4258C14.178 11.3561 14.1371 11.201 14.208 11.0781L15.4523 8.92309ZM16.7513 9.67309C16.8219 9.55075 16.9719 9.50509 17.0977 9.57775L17.5267 9.82541C17.6474 9.89509 17.6882 10.0503 17.6173 10.1731L16.3731 12.3281C16.3025 12.4505 16.1525 12.4961 16.0267 12.4235L15.5977 12.1758C15.477 12.1061 15.4361 11.951 15.5071 11.8281L16.7513 9.67309ZM4.62693 2.67309C4.69756 2.55075 4.8475 2.50509 4.97336 2.57775L5.40231 2.82541C5.52301 2.89509 5.56388 3.05025 5.49296 3.17309L4.24874 5.32814C4.17811 5.45048 4.02817 5.49615 3.90231 5.42348L3.47336 5.17583C3.35266 5.10614 3.31179 4.95098 3.38271 4.82814L4.62693 2.67309ZM5.92597 3.42309C5.9966 3.30075 6.14654 3.25509 6.2724 3.32775L6.70135 3.57541C6.82204 3.64509 6.86292 3.80025 6.792 3.92309L5.54778 6.07814C5.47714 6.20048 5.32721 6.24615 5.20135 6.17348L4.7724 5.92583C4.6517 5.85614 4.61083 5.70098 4.68175 5.57814L5.92597 3.42309Z",
    fill: "url(#paint3_linear_7332_45182)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7332_45182",
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7332_45182",
    x1: 10.5,
    y1: 4,
    x2: 10.5,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E01B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C51335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7332_45182",
    x1: 10.3889,
    y1: 6.875,
    x2: 10.3889,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E4B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7332_45182",
    x1: 10.5,
    y1: 2.54297,
    x2: 10.5,
    y2: 12.4583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0D0D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7332_45182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKoreaFlag);
export default __webpack_public_path__ + "static/media/south-korea-flag.ac39b0bd3e0838809dc4b65fd052f1d5.svg";
export { ForwardRef as ReactComponent };